module.exports = __webpack_public_path__ + "static/media/neil.9c574f18.png";